import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CommonService } from '../../services/common.service';
import { SelectListItem, NewsletterInfo, NewsletterEditViewModelV2 } from '../../models/catalogue-view.model';
import { DomSanitizer, SafeStyle } from '../../../../node_modules/@angular/platform-browser';
import { NewsletterEditNameComponent } from '../../popup-collection/newsletter-edit-name/newsletter-edit-name.component';
import { Subject } from 'rxjs';
import { NgProgressService } from '../../services/ngProgress.service';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { NewsletterService } from '../../services/newsletter.service';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';

@Component({
  selector: 'app-newsletter-edit-v2',
  templateUrl: './newsletter-edit-v2.component.html',
  styleUrls: ['./newsletter-edit-v2.component.css']
})
export class NewsletterEditV2Component implements OnInit {

  accountId: string;
  currentUserModel: CurrentUserModel;

  title: string = "EDIT NEWSLETTER";

  setFullWindow: boolean = true;

  //edit header
  description: string;
  nl_title: string;
  color: string;
  brand: string;
  license: string;
  editNewsletterViewModel: NewsletterInfo;

  newsId: string;
  backUrl: string;

  newsletterEditViewModel: NewsletterEditViewModelV2;
  brandList: SelectListItem[];
  colorList: any[];
  licenseList: SelectListItem[];
  categoryList: SelectListItem[];

  editNewsletterTitle: boolean = false;
  editSection: boolean = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private activeRouter: ActivatedRoute,
    public ngProgress: NgProgressService,
    private commonService: CommonService,
    private newsletterService: NewsletterService,
    private router: Router,
    private dialog: MatDialog,
    private sanitization: DomSanitizer,
    private authService: AuthService
  ) { }

  ngOnInit() {

    //added auth service so I can test without other users accessing the feature before testing is complete
    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CurrentUserModel) => {
  
      this.currentUserModel = res;

      this.accountId = this.currentUserModel.accountId;
      //prevent access via url
      if(res.hideSOH) {
        this.router.navigateByUrl('/home');
      }
    },
      (error: any) => {
        console.error(error);
      });

    /*subscript to watch the route para changes. 
    **************Please make changes inside this subscription. Don't delete it ***************/
    this.activeRouter.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(param => {
      this.ngProgress.start();

      $('.child-loader').animate({ scrollLeft: $('#catalogueedit').width() }, 400);

      this.colorList = NewsletterService.colorList;
      this.newsId = param.get('sku');

      this.activeRouter.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
        this.backUrl = value[0].path;
      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        });

      this.newsletterService.getNewsletterHeader(this.newsId).subscribe((res: NewsletterEditViewModelV2) => {
        this.newsletterEditViewModel = res;
        this.newsletterService.monitorColorChange(this.newsletterEditViewModel.color);
        if (this.newsletterEditViewModel.title) {
          this.nl_title = this.newsletterEditViewModel.title;
        } else {
          this.nl_title = "New Newsletter";
          this.newsletterService.monitorEditNewsletterInfoChange(res);
        }
        this.description = decodeURIComponent(this.newsletterEditViewModel.description);

        if (this.newsletterEditViewModel.containsRestricted && !this.newsletterEditViewModel.license) {
         this.commonService.implementToast('Current newsletter contains restricted items but does not have a license applied. Does this newsletter require a license?','Error');
        }
        this.brandList = res.brandList;
        this.licenseList = res.licenseList;
        this.categoryList = res.categoryList;
        this.ngProgress.done();
      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        });
    });
  }

  updateDescription(description: string, headerType: string): void {

    this.ngProgress.start();

    if (description) {
      this.newsletterService.saveHeaderSQL(this.newsId, description.toUpperCase(), headerType).subscribe((res: NewsletterInfo) => {
        this.newsletterService.getNewsletterHeader(res.news_id).subscribe((res: NewsletterEditViewModelV2) => {
          this.newsletterEditViewModel = res;
          if (this.newsletterEditViewModel.title) {
            this.nl_title = this.newsletterEditViewModel.title;
          } else {
            this.nl_title = "New Newsletter";
          }
          this.description = decodeURIComponent(this.newsletterEditViewModel.description);
          this.brandList = res.brandList;
          this.newsletterService.monitorEditNewsletterInfoChange(res);
          this.ngProgress.done();
        },
          (error: any) => {
            console.info(error);
            this.ngProgress.done();
          });
      });
    }
  }

  checkDescription(description: string): void {
    if (!description) {
      this.commonService.implementToast('description can not be blank', 'Error');
    }
  }

  colorScheme(event: any, headerType: string): void {

    let selectedValue = event.target.value;
    this.ngProgress.start();
    this.newsletterService.saveHeaderSQL(this.newsId, selectedValue, headerType).subscribe((res: NewsletterInfo) => {
        this.newsletterService.getNewsletterHeader(res.news_id).subscribe((res: NewsletterEditViewModelV2) => {
        this.newsletterEditViewModel = res;
        this.newsletterService.monitorColorChange(this.newsletterEditViewModel.color);
        if (this.newsletterEditViewModel.title) {
          this.nl_title = this.newsletterEditViewModel.title;
        } else {
          this.nl_title = "New Newsletter";
        }
        this.description = decodeURIComponent(this.newsletterEditViewModel.description);
        this.brandList = res.brandList;
        this.newsletterService.monitorEditNewsletterInfoChange(res);
        this.ngProgress.done();
      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        });
    });
  }

  selectedBrand(event: any, headerType: string): void {

    let selectedBrand = event.target.value;
    this.ngProgress.start();
    this.newsletterService.newSaveHeader(this.newsId, selectedBrand, headerType, this.newsletterEditViewModel.license).subscribe((res: NewsletterInfo) => {
        this.newsletterService.getNewsletterHeader(res.news_id).subscribe((res: NewsletterEditViewModelV2) => {
        this.newsletterEditViewModel = res;
        if (this.newsletterEditViewModel.title) {
          this.nl_title = this.newsletterEditViewModel.title;
        } else {
          this.nl_title = "New Newsletter";
        }
        this.description = decodeURIComponent(this.newsletterEditViewModel.description);
        this.brandList = res.brandList;
        this.licenseList = res.licenseList;
        this.categoryList = res.categoryList;
        this.newsletterService.monitorEditNewsletterInfoChange(res);
        this.ngProgress.done();
      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        });
    });
  }

  updateHeader(event: any, headerType: string): void {
    // remove the lists of brands and licenses from the header model before sending to the backend to update
    this.ngProgress.start();
    this.newsletterEditViewModel.brandList = [];
    this.newsletterEditViewModel.licenseList = [];
    
    let changedValue = encodeURIComponent(event.target.value);

    if (headerType != 'category' && !this.newsletterEditViewModel.category)
    {
      this.commonService.implementToast('Category has not been applied to the current newsletter', 'Warning', false);
    }

    // only change value to upper case when it is not the colour as colour has lots of functionality that needs to be changed elsewhere when it is in uppercase
    if (headerType != 'color')
    {
      changedValue = changedValue.toUpperCase()
    }
    this.newsletterService.saveHeaderSQL(this.newsId, changedValue, headerType).subscribe((res: NewsletterInfo) => {
        this.newsletterService.getNewsletterHeader(res.news_id).subscribe((res: NewsletterEditViewModelV2) => {
        this.newsletterEditViewModel = res;
        if (this.newsletterEditViewModel.title) {
          this.nl_title = this.newsletterEditViewModel.title;
        } else {
          this.nl_title = "New Newsletter";
        }
        this.description = decodeURIComponent(this.newsletterEditViewModel.description);
        this.brandList = res.brandList;
        this.licenseList = res.licenseList;
        this.categoryList = res.categoryList;
        this.newsletterService.monitorEditNewsletterInfoChange(res);
        this.ngProgress.done();
      },
        (error: any) => {
          console.info(error);
          this.ngProgress.done();
        });
    });
  }

  saveHeader(headerType: string): void {
    const dialogRef = this.dialog.open(NewsletterEditNameComponent, {
      width: '500px',
      data: { nl_title: this.nl_title },
      panelClass: 'mat-dialog-wrapper'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        result.nl_title = result.nl_title ? result.nl_title.trim().replace('\/', '\\').toUpperCase() : 'New Newsletter'; 
        result.nl_title = encodeURIComponent(result.nl_title);

        this.newsletterService.checkUniqueTitle(this.newsId, result.nl_title).subscribe((res: boolean) => {
          if (res == true) {
            this.newsletterService.saveHeaderSQL(this.newsId, result.nl_title.toUpperCase(), headerType).subscribe((res: NewsletterInfo) => {
              this.newsletterService.getNewsletterHeader(res.news_id).subscribe((res: NewsletterEditViewModelV2) => {
              this.newsletterEditViewModel = res;
              if (this.newsletterEditViewModel.title) {
                this.nl_title = this.newsletterEditViewModel.title;
              } else {
                this.nl_title = 'New Newsletter';
              }
              this.description = decodeURIComponent(this.newsletterEditViewModel.description);
              this.brandList = res.brandList;
              this.newsletterService.monitorEditNewsletterInfoChange(res);
              this.editNewsletterTitle = false;
              this.ngProgress.done();
            },
              (error: any) => {
                console.info(error);
                this.ngProgress.done();
              });
          });
          } else {
            this.commonService.implementToast('There is already a newsletter with the provided title, please choose a unique title.', 'Warning', false);
          }
        });
      }
    });
  }

  cancelNewsletterTitle(): void {
    this.editNewsletterTitle = false;
  }

  safeStyle(style: string): SafeStyle {
    return this.sanitization.bypassSecurityTrustStyle(style);
  }

  receiveEditPromoEvent($event) {
    this.editSection = $event;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    $('.child-loader').animate({ scrollLeft: -$('#catalogueedit').width() }, 400);
    this.router.navigateByUrl('/catalogueedit');
  }
}
